module.exports = __webpack_public_path__ + "static/img/使用-act.71bf9f25.png";